module.exports = __webpack_public_path__ + "img/76.625fac4c.jpg";